<div class="icon"
  data-nw-modal-target="#messagingLoginModal"
  data-nw-modal-options='{"backdrop":true, "keyboard":true}'
  #toggle
>
  <svg height="50" viewBox="0 0 1792 1792" width="50" xmlns="http://www.w3.org/2000/svg">
    <path fill="#a1e9f2" d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"/>
  </svg>
</div>

<div id="messagingLoginModal" class="modal" role="dialog" aria-hidden="true" #LoginModal>
  <div class="modal-dialog">
      <div class="modal-content">
          <button type="button" class="close" #dismissButton data-nw-modal-dismiss aria-label="Close" (click)="loginComponent.reset()">X</button>
          <div class="modal-header">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                  <button
                    class="nav-link active"
                    id="login-tab"
                    type="button"
                    role="tab"
                    aria-selected="true"
                  >{{ 'Login' | localize }}/{{ 'Register' | localize}}</button>
              </li>
          </ul>
          </div>
          <div class="modal-body">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="login" role="tabpanel">
                <nw-login
                  #loginComponent
                  (loginWithBankId)="loginWithBankId(bankIdSigningModal); dismissButton.click()"
                  (dismissLoginModal)="dismissButton.click()"
                ></nw-login>
              </div>
            </div>
          </div>
      </div>
  </div>
</div>

<nw-bankid-signing-modal #bankIdSigningModal (modalSave)="bankIdSignIn($event)" (modalClosed)="toggle.click()"></nw-bankid-signing-modal>
